import { render, staticRenderFns } from "./QuizMediaContentForm.vue?vue&type=template&id=158ea519&"
import script from "./QuizMediaContentForm.vue?vue&type=script&lang=js&"
export * from "./QuizMediaContentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports